import { render } from "./GeeCaptcha.vue?vue&type=template&id=04c7c42e"
import script from "./GeeCaptcha.vue?vue&type=script&lang=js"
export * from "./GeeCaptcha.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__